import React, { useState } from "react";
import { useEffect } from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import PaymentPlanWindow from "../components/PaymentPlanWindow";
import { setLoginTime } from "../utils/sessionTime";
import { useWindowSize } from "../hooks/windowSize";

import { trackPageVisit } from "../competency/PageTracker";
import Swal from "sweetalert2";
import MinimizerDetector from "../components/MinimizerDetector";


// after successful login
setLoginTime();

// On the destination homepage




function HomePage() {

  const [userId, setUserId] = useState(null); 



  const getUserIdFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const encoded = params.get('u');
  
  if (encoded) {
    const userId = atob(encoded); // Decode
    setUserId(userId);
    return userId;
  }
  return null;
};



  useEffect(() => {
    const userId = getUserIdFromURL();
    if (userId) {
      console.log('User ID:', userId);
    }
  }, [userId]);


  const { width, height, isMobile, isTablet, isDesktop } = useWindowSize();
  const deviceType = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";

  useEffect(() => {

    if (deviceType === "Mobile") {
      Swal.fire({
        title: "Mobile Access Detected",
        text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
        icon: "info",
        confirmButtonText: "OK"
      }).then(() => {
        console.log("Mobile access detected, showing alert");
        return;
      });
    } else if (deviceType === "Tablet") {
      Swal.fire({
        title: "Tablet Access Detected",
        text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
        icon: "info",
        confirmButtonText: "OK"
      }).then(() => {
        console.log("Tablet access detected, showing alert");
        return;
      });
    } else {
      return;
    }


  }, [width, height, isMobile, isTablet, isDesktop]);

  //const isMobile = window.innerWidth <= 1024;

  useEffect(() => {

    trackPageVisit("HomePage");

  }, []);




  const checkMobileRedirect = () => {
    if (deviceType === "Mobile") {

      Swal.fire({
        title: "Mobile Access Detected",
        text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
        icon: "info",
        confirmButtonText: "OK"
      }).then(() => {
        // Optionally, you can redirect to a mobile-friendly page or close the simulator
        // window.location.href = "/mobile-info"; // Example redirect
        console.log("Mobile access detected, showing alert");
        return false;
      });
    } else if (deviceType === "Tablet") {
      Swal.fire({
        title: "Tablet Access Detected",
        text: "For the best experience, please access the DCS Simulator on a desktop or laptop computer.",
        icon: "info",
        confirmButtonText: "OK"
      }).then(() => {
        console.log("Tablet access detected, showing alert");
        return false;
      });
    } else {
      return true;
    }
  };


  const navigate = useNavigate();

  // ================= ICON DATA =================
  const [desktopIcons, setDesktopIcons] = useState([
    {
      id: 1,
      name: "Refinery",
      image: "/icons/Refinery.png",
      x: 40,
      y: 90,
      plants: [
        {
          name: "1000 BPD Modular Refinery",
          status: "green",
          equipment: [
            "Unloading System",
            "Tank Farm System",
            "Crude Pumps",
            "Heat Exchanger Units",
            "Furnace",
            "Distillation Column",
            "Stripper",
            "Kettle Reboiler",
            "Control Valves",
            "Reflux Drum",
            "Naptha Vaporization System",
            "Instrument Air System",
            "Nitrogen Generation Unit",
            "Steam Boiler System",
            "Product Loading Unit",
          ],
        },
        {
          name: "30,000 BPD Modular Refinery",
          status: "green",
          equipment: [
            "Crude Heater",
            "Vacuum Column",
            "Hydrotreater",
          ],
        },
        {
          name: "10,000 BPD Hydroskimming Refinery",
          status: "red",
          equipment: [
            "Crude Heater",
            "Atmospheric Column",
            "Reformer Unit",
          ],
        },
        
        {
          name: "100,000 BPD Conventional Refinery",
          status: "red",
          equipment: [
            "CDU",
            "VDU",
            "FCC Unit",
            "Hydrocracker",
          ],
        },
      ],
    },

    {
      id: 2,
      name: "Gas Plant",
      image: "/icons/Gas Plant.png",
      x: 40,
      y: 220,
      plants: [
        {
          name: "50 MMSCFD Gas Plant",
          status: "red",
          equipment: ["Slug Catcher", "Inlet Separator", "Dehydration Unit"],
        },
        {
          name: "200 MMSCFD Gas Processing Plant",
          status: "red",
          equipment: ["Amine Unit", "TEG Unit", "Compression Train"],
        },
        {
          name: "500 MMSCFD LNG Feed Gas Plant",
          status: "red",
          equipment: ["Acid Gas Removal", "Dehydration", "NGL Recovery"],
        },
      ],
    },

    {
      id: 3,
      name: "Offshore",
      image: "/icons/offshore.png",
      x: 40,
      y: 350,
      plants: [
        {
          name: "250,000 BPD Offshore Production DCS",
          status: "green",
          equipment: [
            "Dry Gas Well and Wellhead Assembly",
            "Crude Dominated Well and Wellhead Assembly",
            "Mix Well and Wellhead Assembly",
            "Wellhead Manifold",
            "Pig Launcher and Pig Reciever",
            "Test Separator",
            "First Stage Separator",
            "Second Stage Separator",
            "Third Stage Separator",
            "Sludge Catcher",
            "Crude Dehydrator",
            "Crude Export System",
            "Gas Compression System",
            "Gas Sweetening System",
            "TEG Contactor and Regeneration System",
            "Gas Export System",
            "Produced Water Treatment",
            "Sea Water Treatment",
            "Water Injection System",
            "Corrosion Inhibition System",
            "Flare System",
          ],
        },
      ],
    },

    {
      id: 4,
      name: "Onshore",
      image: "/icons/onshore.png",
      x: 180,
      y: 90,
      plants: [
        {
          name: "Onshore Production Facility (OPF)",
          status: "red",
          equipment: ["Separator Train", "Heater Treater", "Storage Tank"],
        },
        {
          name: "Gathering Station System",
          status: "red",
          equipment: ["Flowlines", "Manifold", "Test Separator"],
        },
      ],
    },

    {
      id: 5,
      name: "Methanol",
      image: "/icons/methanol.png",
      x: 180,
      y: 220,
      plants: [
        {
          name: "Small Scale Methanol Plant",
          status: "red",
          equipment: ["Reformer", "Shift Reactor", "Methanol Reactor"],
        },
        {
          name: "Industrial Methanol Complex",
          status: "red",
          equipment: ["Syngas Unit", "Compression", "Distillation"],
        },
      ],
    },

    {
      id: 6,
      name: "Ethanol",
      image: "/icons/ethanol.jpg",
      x: 180,
      y: 350,
      plants: [
        {
          name: "Bio-Ethanol Plant",
          status: "red",
          equipment: ["Fermenter", "Distillation", "Dehydration Unit"],
        },
        {
          name: "Industrial Ethanol Production Unit",
          status: "red",
          equipment: ["Mash Tank", "Column", "Storage"],
        },
      ],
    },
  ]);


  const [showPaymentWindow, setShowPaymentWindow] = useState(false);

  // ================= DRAG ICON =================
  const [draggingId, setDraggingId] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // ================= WINDOWS =================
  const [selectedIcon, setSelectedIcon] = useState(null);

  const [selectedPlantItem, setSelectedPlantItem] = useState(null);

  const [windowPos, setWindowPos] = useState({ x: 300, y: 120 });
  const [windowDragging, setWindowDragging] = useState(false);
  const [windowOffset, setWindowOffset] = useState({ x: 0, y: 0 });

  const [lockPopup, setLockPopup] = useState(false);

  const [systemPos, setSystemPos] = useState({ x: 420, y: 150 });
  const [systemDragging, setSystemDragging] = useState(false);
  const [systemOffset, setSystemOffset] = useState({ x: 0, y: 0 });

  // ================= ICON CLICK =================
  const handleIconDoubleClick = (icon) => {
    setSelectedIcon(icon);
    setSelectedPlantItem(null);
  };

  // ================= PLANT CLICK =================
  const handlePlantClick = (plant) => {
    if (plant.status === "red") {
      setLockPopup(true);
      setSelectedPlantItem(null);
    } else {
      setSelectedPlantItem(plant);
      setLockPopup(false);
    }
  };

  // ================= ICON DRAG =================
  const startDrag = (e, icon) => {
    setDraggingId(icon.id);
    setOffset({
      x: e.clientX - icon.x,
      y: e.clientY - icon.y,
    });
  };

  const handleMouseMove = (e) => {
    if (draggingId) {
      setDesktopIcons((prev) =>
        prev.map((icon) =>
          icon.id === draggingId
            ? {
              ...icon,
              x: e.clientX - offset.x,
              y: e.clientY - offset.y,
            }
            : icon
        )
      );
    }

    if (windowDragging) {
      setWindowPos({
        x: e.clientX - windowOffset.x,
        y: e.clientY - windowOffset.y,
      });
    }

    if (systemDragging) {
      setSystemPos({
        x: e.clientX - systemOffset.x,
        y: e.clientY - systemOffset.y,
      });
    }
  };

  const stopDrag = () => {
    setDraggingId(null);
    setWindowDragging(false);
    setSystemDragging(false);
  };

  const startWindowDrag = (e) => {
    setWindowDragging(true);
    setWindowOffset({
      x: e.clientX - windowPos.x,
      y: e.clientY - windowPos.y,
    });
  };

  const startSystemDrag = (e) => {
    setSystemDragging(true);
    setSystemOffset({
      x: e.clientX - systemPos.x,
      y: e.clientY - systemPos.y,
    });
  };


  const loginAlert = () => {
    if (deviceType === "Mobile") {
      Swal.fire({
        title: "Mobile Access Detected",
        text: "You cannot login on a mobile device.",
        icon: "info",
        confirmButtonText: "OK"
      });
      return;
    } else if (deviceType === "Tablet") {
      Swal.fire({
        title: "Tablet Access Detected",
        text: "You cannot login on a tablet device.",
        icon: "info",
        confirmButtonText: "OK"
      });
      return;
    }

    Swal.fire({
      title: "Access Restricted",
      text: "This simulator is in testing stage. Please enter the access password.",
      icon: "info",
      input: "password",
      inputPlaceholder: "Enter password",
      inputAttributes: {
        autocapitalize: "off",
        autocorrect: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Access Simulator",
      cancelButtonText: "Cancel",
      preConfirm: (password) => {
        if (!password) {
          Swal.showValidationMessage("Password is required");
          return false;
        }
        return password;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const enteredPassword = result.value;
        const correctPassword = "testdcs123"; // Change this to your desired password

        if (enteredPassword === correctPassword) {
          Swal.fire({
            icon: "success",
            title: "Access Granted",
            text: "Redirecting to DCS Simulator...",
            timer: 1500,
            showConfirmButton: false
          }).then(() => {
            navigate("/WellComp", { state: { fromLogin: true } });
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Wrong Password",
            text: "Incorrect password. Please contact your instructor for access.",
            confirmButtonText: "Try Again"
          }).then(() => {
            // Optionally, allow retry by calling loginAlert again
            loginAlert();
          });
        }
      }
    });
  };


  return (
    <div
      className="desktop-home"
      onMouseMove={handleMouseMove}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
    >
      {/* Minimizer Detector - Only on desktop/tablet */}
      {!isMobile && <MinimizerDetector />}
      
      {/* HEADER */}
      <div className="desktop-header">
        NK Tech Industrial DCS System
      </div>

      {/* ICONS */}
      {desktopIcons.map((icon) => (
        <div
          key={icon.id}
          className="desktop-icon"
          style={{ left: icon.x, top: icon.y, position: "absolute" }}
          onMouseDown={(e) => startDrag(e, icon)}
          onClick={() => handleIconDoubleClick(icon)}
        >
          <img src={icon.image} className="desktop-icon-img" alt="" />
          <span className="desktop-icon-text">{icon.name}</span>
        </div>
      ))}

      {/* ================= WINDOW 1 - Plant List ================= */}
      {selectedIcon && !selectedPlantItem && (
        <div className="plant-window plant-window-list">
          <div className="plant-window-header" onMouseDown={startWindowDrag}>
            <span>{selectedIcon.name} Plants</span>
            <button onClick={() => setSelectedIcon(null)}>✕</button>
          </div>

          <div className="plant-window-body">
            {selectedIcon.plants.map((p, i) => (
              <div
                key={i}
                className={`plant-item ${p.status}`}
                onClick={() => handlePlantClick(p)}
              >
                {p.status === "red" ? "🔒 " : " "}
                {p.name}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ================= LOCK POPUP ================= */}
      {lockPopup && (
        <div className="plant-window plant-window-lock">
          <div className="plant-window-header">
            <span>Access Denied</span>
            <button onClick={() => setLockPopup(false)}>✕</button>
          </div>
          <div className="plant-window-body">
            <p>DCS System is Still Undergoing Development - Check back Later</p>
          </div>
        </div>
      )}


      {/* ================= WINDOW 3 - Plant Details ================= */}
      {selectedPlantItem && (
        <div className="plant-window plant-window-details">
          <div className="plant-window-header" onMouseDown={startSystemDrag}>
            <span>{selectedPlantItem.name}</span>
            <button onClick={() => setSelectedPlantItem(null)}>✕</button>
          </div>

          <div className="plant-window-body">
            <h4>Purchasing this DCS training package will enable you gain practical experience in operating fully simulated industrial equipment listed below. You will interact with real process units and controls designed to mirror live plant operations used in modern oil and gas facilities globally.</h4>

            {selectedPlantItem.equipment.map((eq, i) => (
              <div key={i} className="plant-item green">
                ✔ {eq}
              </div>
            ))}

            <button
              className="preview-plan-btn"
              onClick={() => setShowPaymentWindow(true)}
            >
              Payment Plan
            </button>

            {showPaymentWindow && (
              <PaymentPlanWindow
                onClose={() => setShowPaymentWindow(false)}
                selectedSystemName = {selectedPlantItem.name}
                userId = {userId ? true : false}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;